import React, { useEffect, useState } from 'react';
const LANGS = [['hu','Magyar'],['en','English'],['de','Deutsch'],['fr','Français'],['it','Italiano'],['es','Español']];

const card = { background: '#1a1d27', border: '1px solid #2a2e3a', borderRadius: 12, padding: 16 };
const title = { fontSize: 13, color: '#8b8fa3', fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 };
const inp = { background: '#0a0d14', border: '1px solid #2a2e3a', borderRadius: 6, padding: '8px 12px', color: '#e4e6eb', fontSize: 13, width: '100%', boxSizing: 'border-box' };
const btn = (bg) => ({ padding: '8px 16px', borderRadius: 6, border: 'none', background: bg, color: bg === '#f43f5e' ? '#fff' : '#0a0d14', cursor: 'pointer', fontWeight: 600, fontSize: 12 });
const lbl = { fontSize: 11, color: '#8b8fa3', display: 'block', marginBottom: 4 };

const fmtDate = (ms) => ms ? new Date(ms).toLocaleDateString('hu-HU') : '—';
const fmtUSD = (n) => `$${(Number(n) || 0).toFixed(2)}`;
const fmtHUF = (n) => `${Math.round(Number(n) || 0).toLocaleString('hu-HU')} Ft`;
const fmtEUR = (n) => `€${(Number(n) || 0).toFixed(2)}`;

export default function Affiliates() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);

  // Új partner form
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [rate, setRate] = useState('0.25');
  const [email, setEmail] = useState('');
  const [type, setType] = useState('influencer');
  const [lang, setLang] = useState('hu');

  // Edit
  const [editCode, setEditCode] = useState(null);
  const [eRate, setERate] = useState('');
  const [eEmail, setEEmail] = useState('');
  const [eActive, setEActive] = useState(true);
  const [eLang, setELang] = useState('hu');

  // Drill-down
  const [detailCode, setDetailCode] = useState(null);
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);

  const flash = (text, ok = true) => { setMsg({ text, ok }); setTimeout(() => setMsg(null), 4000); };

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const res = await fetch('/api/affiliates', { credentials: 'include' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setData(await res.json());
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const loadDetail = async (c) => {
    setDetailCode(c); setDetail(null); setDetailLoading(true);
    try {
      const res = await fetch(`/api/affiliates/${encodeURIComponent(c)}/conversions`, { credentials: 'include' });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || `HTTP ${res.status}`);
      setDetail(d);
    } catch (e) { flash(e.message, false); setDetailCode(null); }
    finally { setDetailLoading(false); }
  };

  const handleAdd = async () => {
    try {
      const res = await fetch('/api/affiliates', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, code, commissionRate: parseFloat(rate), email, type, lang }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error);
      flash(d.welcomeSent ? `${d.code} létrehozva — üdvözlő e-mail elküldve` : `${d.code} létrehozva${d.welcomeError ? ' (üdvözlő nem ment: ' + d.welcomeError + ')' : ''}`, d.welcomeSent !== false);
      setName(''); setCode(''); setRate('0.25'); setEmail(''); setType('influencer'); setLang('hu');
      load();
    } catch (e) { flash(e.message, false); }
  };

  const resendWelcome = async (p) => {
    try {
      const res = await fetch(`/api/affiliates/${encodeURIComponent(p.code)}/welcome`, { method: 'POST', credentials: 'include' });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error);
      flash(d.welcomeSent ? `Üdvözlő újraküldve: ${p.code}` : 'Az üdvözlő nem ment el', d.welcomeSent);
    } catch (e) { flash(e.message, false); }
  };

  const removePartner = async (p) => {
    const warn = (p.stats && p.stats.conversions > 0)
      ? `\n\nFIGYELEM: ennek a partnernek ${p.stats.conversions} konverziója van. A partner törlődik, de a konverziós/kifizetési rekordok megmaradnak.`
      : '';
    if (!window.confirm(`Biztosan törlöd a(z) ${p.code} partnert?${warn}`)) return;
    try {
      const res = await fetch(`/api/affiliates/${encodeURIComponent(p.code)}`, { method: 'DELETE', credentials: 'include' });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error);
      flash(`${p.code} törölve`);
      if (detailCode === p.code) { setDetailCode(null); setDetail(null); }
      load();
    } catch (e) { flash(e.message, false); }
  };

  const startEdit = (p) => {
    setEditCode(p.code);
    setERate(String(p.commissionRate));
    setEEmail(p.email || '');
    setEActive(p.active);
    setELang(p.lang || 'hu');
  };

  const saveEdit = async () => {
    try {
      const res = await fetch(`/api/affiliates/${encodeURIComponent(editCode)}`, {
        method: 'PUT', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ commissionRate: parseFloat(eRate), email: eEmail, active: eActive, lang: eLang }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error);
      flash('Mentve');
      setEditCode(null);
      load();
    } catch (e) { flash(e.message, false); }
  };

  const toggleActive = async (p) => {
    try {
      const res = await fetch(`/api/affiliates/${encodeURIComponent(p.code)}`, {
        method: 'PUT', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ active: !p.active }),
      });
      if (!res.ok) throw new Error((await res.json()).error || 'Hiba');
      flash(`${p.code} ${!p.active ? 'aktiválva' : 'deaktiválva'}`);
      load();
    } catch (e) { flash(e.message, false); }
  };

  const clawback = async (conversionId) => {
    if (!window.confirm('Biztosan visszavonod (refund) ezt a konverziót?')) return;
    try {
      const res = await fetch(`/api/affiliates/${encodeURIComponent(detailCode)}/clawback`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ conversionId }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error);
      flash(d.alreadyRefunded ? 'Már vissza volt vonva' : 'Visszavonva');
      loadDetail(detailCode); load();
    } catch (e) { flash(e.message, false); }
  };

  const markPaid = async () => {
    const pending = detail?.summary?.pendingUSD || 0;
    if (!window.confirm(`Kifizetés rögzítése: ${fmtUSD(pending)} (${fmtHUF(detail.summary.pendingHUF)})?`)) return;
    const note = window.prompt('Megjegyzés (opcionális):', '') || '';
    try {
      const res = await fetch(`/api/affiliates/${encodeURIComponent(detailCode)}/payout`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error);
      flash(`Kifizetés rögzítve: ${fmtUSD(d.amountUSD)}`);
      loadDetail(detailCode); load();
    } catch (e) { flash(e.message, false); }
  };

  const s = data?.summary;

  return (
    <div style={{ padding: 20 }}>
      <h1 style={{ color: '#e4e6eb', margin: 0, fontSize: 24, marginBottom: 20 }}>Affiliate partnerek</h1>

      {msg && (
        <div style={{ padding: '10px 16px', borderRadius: 8, marginBottom: 16, background: msg.ok ? '#1f3a1e' : '#3a1e1e', color: msg.ok ? '#86efac' : '#fca5a5', fontSize: 13 }}>
          {msg.text}
        </div>
      )}

      {/* Globális összesítő */}
      {s && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginBottom: 20 }}>
          <div style={card}>
            <div style={title}>Össz. fizetendő (függő)</div>
            <div style={{ fontSize: 22, color: '#fbbf24', fontWeight: 700 }}>{fmtHUF(s.totalPendingHUF)}</div>
            <div style={{ fontSize: 13, color: '#8b8fa3', marginTop: 2 }}>{fmtEUR(s.totalPendingEUR)} · {fmtUSD(s.totalPendingUSD)}</div>
            {s.excluded && s.excluded.count > 0 && (
              <div style={{ fontSize: 11, color: '#fbbf24', marginTop: 6, lineHeight: 1.5 }}>
                Kihagyva {fmtUSD(s.excluded.pendingUSD)} teszt-partnertől
                ({s.excluded.codes.join(', ')}) — nem valódi kifizetendő.
              </div>
            )}
          </div>
          <div style={card}>
            <div style={title}>Eddig kifizetve</div>
            <div style={{ fontSize: 22, color: '#86efac', fontWeight: 700 }}>{fmtUSD(s.totalPaidUSD)}</div>
            <div style={{ fontSize: 13, color: '#8b8fa3', marginTop: 2 }}>
              {s.partnerCount} partner · {s.enabledCount != null ? s.enabledCount : s.activeCount} engedélyezett
            </div>
            {s.producingCount != null && (
              <div style={{ fontSize: 11, color: s.producingCount ? '#86efac' : '#fbbf24', marginTop: 4 }}>
                ebből <b>{s.producingCount}</b> hozott már konverziót
              </div>
            )}
          </div>
          <div style={card}>
            <div style={title}>Top partnerek (függő)</div>
            {s.top.length === 0 ? <div style={{ fontSize: 13, color: '#8b8fa3' }}>—</div> : s.top.map(t => (
              <div key={t.code} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#e4e6eb', padding: '2px 0' }}>
                <span style={{ color: '#00d4ff', fontFamily: 'monospace' }}>{t.code}</span>
                <span>{fmtUSD(t.pendingUSD)}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Új partner */}
      <div style={{ ...card, marginBottom: 20 }}>
        <div style={title}>Új partner</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginTop: 12 }}>
          <div><label style={lbl}>Név *</label><input style={inp} value={name} onChange={e => setName(e.target.value)} placeholder="Partner neve" /></div>
          <div><label style={lbl}>Kód * (NAGYBETŰ)</label><input style={inp} value={code} onChange={e => setCode(e.target.value.toUpperCase())} placeholder="PARTNER_01" /></div>
          <div><label style={lbl}>Jutalék (0–1)</label><input style={inp} type="number" step="0.01" min="0" max="1" value={rate} onChange={e => setRate(e.target.value)} /></div>
          <div><label style={lbl}>Email *</label><input style={inp} value={email} onChange={e => setEmail(e.target.value)} placeholder="partner@example.com" /></div>
          <div><label style={lbl}>Típus</label><input style={inp} value={type} onChange={e => setType(e.target.value)} placeholder="influencer" /></div>
          <div><label style={lbl}>Nyelv (üdvözlő/levelek)</label>
            <select style={inp} value={lang} onChange={e => setLang(e.target.value)}>
              {LANGS.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
            </select>
          </div>
        </div>
        <div style={{ marginTop: 12 }}><button style={btn('#00D4FF')} onClick={handleAdd}>Hozzáadás</button></div>
      </div>

      {/* Lista */}
      {loading ? (
        <div style={{ color: '#8b8fa3' }}>Betöltés...</div>
      ) : error ? (
        <div style={{ color: '#f43f5e' }}>Hiba: {error}</div>
      ) : (
        <div style={card}>
          <div style={title}>Partnerek ({data.partners.length})</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {data.partners.map(p => (
              <div key={p.code} style={{ background: '#0a0d14', borderRadius: 8, padding: '12px 16px', border: p.active ? '1px solid #2a2e3a' : '1px solid #3a2e2e', opacity: p.active ? 1 : 0.6 }}>
                {editCode === p.code ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 }}>
                      <div><label style={lbl}>Jutalék</label><input style={inp} type="number" step="0.01" min="0" max="1" value={eRate} onChange={e => setERate(e.target.value)} /></div>
                      <div><label style={lbl}>Email</label><input style={inp} value={eEmail} onChange={e => setEEmail(e.target.value)} /></div>
                      <div><label style={lbl}>Aktív</label>
                        <select style={inp} value={eActive ? 'true' : 'false'} onChange={e => setEActive(e.target.value === 'true')}>
                          <option value="true">Igen</option><option value="false">Nem</option>
                        </select>
                      </div>
                      <div><label style={lbl}>Nyelv</label>
                        <select style={inp} value={eLang} onChange={e => setELang(e.target.value)}>
                          {LANGS.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
                        </select>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button style={btn('#22c55e')} onClick={saveEdit}>Mentés</button>
                      <button style={btn('#2a2e3a')} onClick={() => setEditCode(null)}>Mégse</button>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                    <div style={{ flex: 1, minWidth: 220, cursor: 'pointer' }} onClick={() => loadDetail(p.code)}>
                      <div style={{ fontSize: 14, color: '#e4e6eb', fontWeight: 600 }}>
                        <span style={{ color: '#00d4ff', fontFamily: 'monospace' }}>{p.code}</span> · {p.name}
                      </div>
                      <div style={{ fontSize: 11, color: '#8b8fa3', marginTop: 2 }}>
                        {(p.commissionRate * 100).toFixed(0)}% · {p.type} · {p.email || 'nincs email'} · létrehozva {fmtDate(p.createdAt)}
                      </div>
                      <div style={{ fontSize: 12, color: '#8b8fa3', marginTop: 4 }}>
                        {p.stats.conversions} konv. · függő: <span style={{ color: '#fbbf24', fontWeight: 600 }}>{fmtUSD(p.stats.pendingUSD)}</span> · kifizetve: {fmtUSD(p.stats.paidUSD)}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                      <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 600, background: p.active ? '#1f3a1e' : '#3a1e1e', color: p.active ? '#86efac' : '#fca5a5' }}>{p.active ? 'Aktív' : 'Inaktív'}</span>
                      <button style={{ ...btn('#2a2e3a'), color: '#e4e6eb', fontSize: 11 }} onClick={() => loadDetail(p.code)}>Részletek</button>
                      <button style={{ ...btn('#2a2e3a'), color: '#e4e6eb', fontSize: 11 }} onClick={() => toggleActive(p)}>{p.active ? 'Deakt.' : 'Akt.'}</button>
                      <button style={{ ...btn('#2a2e3a'), color: '#e4e6eb', fontSize: 11 }} onClick={() => startEdit(p)}>Szerk.</button>
                      <button style={{ ...btn('#2a2e3a'), color: '#e4e6eb', fontSize: 11 }} onClick={() => resendWelcome(p)} title="Üdvözlő e-mail újraküldése">✉ Üdvözlő</button>
                      <button style={{ ...btn('#f43f5e'), fontSize: 11 }} onClick={() => removePartner(p)}>Töröl</button>
                    </div>
                  </div>
                )}
              </div>
            ))}
            {data.partners.length === 0 && <div style={{ color: '#8b8fa3', fontSize: 13 }}>Nincs partner</div>}
          </div>
        </div>
      )}

      {/* Drill-down: per-partner nézet */}
      {detailCode && (
        <div style={{ ...card, marginTop: 20, border: '1px solid #00d4ff' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <div style={title}>Partner részletek — {detailCode}</div>
            <button style={{ ...btn('#2a2e3a'), color: '#e4e6eb', fontSize: 11 }} onClick={() => { setDetailCode(null); setDetail(null); }}>Bezárás ✕</button>
          </div>

          {detailLoading ? (
            <div style={{ color: '#8b8fa3' }}>Betöltés...</div>
          ) : detail ? (
            <>
              {/* Összegzők */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 16 }}>
                <div style={{ background: '#0a0d14', borderRadius: 8, padding: 12 }}>
                  <div style={{ fontSize: 11, color: '#8b8fa3' }}>Konverziók</div>
                  <div style={{ fontSize: 20, color: '#e4e6eb', fontWeight: 700 }}>{detail.summary.conversions}</div>
                </div>
                <div style={{ background: '#0a0d14', borderRadius: 8, padding: 12 }}>
                  <div style={{ fontSize: 11, color: '#8b8fa3' }}>Jutalék (refund nélkül)</div>
                  <div style={{ fontSize: 20, color: '#e4e6eb', fontWeight: 700 }}>{fmtUSD(detail.summary.earnedUSD)}</div>
                  <div style={{ fontSize: 11, color: '#8b8fa3' }}>refunded: {fmtUSD(detail.summary.refundedCommissionUSD)}</div>
                </div>
                <div style={{ background: '#0a0d14', borderRadius: 8, padding: 12 }}>
                  <div style={{ fontSize: 11, color: '#8b8fa3' }}>Fizetendő (függő)</div>
                  <div style={{ fontSize: 20, color: '#fbbf24', fontWeight: 700 }}>{fmtHUF(detail.summary.pendingHUF)}</div>
                  <div style={{ fontSize: 11, color: '#8b8fa3' }}>{fmtEUR(detail.summary.pendingEUR)} · {fmtUSD(detail.summary.pendingUSD)}</div>
                </div>
                <div style={{ background: '#0a0d14', borderRadius: 8, padding: 12 }}>
                  <div style={{ fontSize: 11, color: '#8b8fa3' }}>Kifizetve</div>
                  <div style={{ fontSize: 20, color: '#86efac', fontWeight: 700 }}>{fmtUSD(detail.summary.paidUSD)}</div>
                  <button style={{ ...btn('#22c55e'), marginTop: 6, fontSize: 11 }} disabled={detail.summary.pendingUSD <= 0} onClick={markPaid}>Kifizetve →</button>
                </div>
              </div>

              {/* Konverziók táblázat */}
              <div style={{ ...title, marginTop: 8 }}>Konverziók</div>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                  <thead>
                    <tr style={{ color: '#8b8fa3', textAlign: 'left', borderBottom: '1px solid #2a2e3a' }}>
                      <th style={{ padding: '6px 8px' }}>Dátum</th>
                      <th style={{ padding: '6px 8px' }}>Termék</th>
                      <th style={{ padding: '6px 8px' }}>Platform</th>
                      <th style={{ padding: '6px 8px', textAlign: 'right' }}>Gross</th>
                      <th style={{ padding: '6px 8px', textAlign: 'right' }}>Net</th>
                      <th style={{ padding: '6px 8px', textAlign: 'right' }}>Jutalék</th>
                      <th style={{ padding: '6px 8px', textAlign: 'center' }}>Státusz</th>
                      <th style={{ padding: '6px 8px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {detail.conversions.map(c => (
                      <tr key={c.id} style={{ borderBottom: '1px solid #1a1d27', color: c.refunded ? '#8b8fa3' : '#e4e6eb', opacity: c.refunded ? 0.6 : 1 }}>
                        <td style={{ padding: '6px 8px' }}>{fmtDate(c.purchaseAt)}</td>
                        <td style={{ padding: '6px 8px', fontFamily: 'monospace' }}>{c.productId}</td>
                        <td style={{ padding: '6px 8px' }}>{c.platform}</td>
                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{fmtUSD(c.grossUSD)}</td>
                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>{fmtUSD(c.netUSD)}</td>
                        <td style={{ padding: '6px 8px', textAlign: 'right', fontWeight: 600 }}>{fmtUSD(c.commissionUSD)}</td>
                        <td style={{ padding: '6px 8px', textAlign: 'center' }}>
                          <span style={{ padding: '2px 6px', borderRadius: 4, fontSize: 10, background: c.refunded ? '#3a1e1e' : '#1f3a1e', color: c.refunded ? '#fca5a5' : '#86efac' }}>
                            {c.refunded ? 'Refunded' : 'OK'}
                          </span>
                        </td>
                        <td style={{ padding: '6px 8px', textAlign: 'right' }}>
                          {!c.refunded && <button style={{ ...btn('#f43f5e'), fontSize: 10, padding: '4px 8px' }} onClick={() => clawback(c.id)}>Clawback</button>}
                        </td>
                      </tr>
                    ))}
                    {detail.conversions.length === 0 && (
                      <tr><td colSpan={8} style={{ padding: 12, color: '#8b8fa3' }}>Nincs konverzió</td></tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Payout történet */}
              {detail.payouts.length > 0 && (
                <>
                  <div style={{ ...title, marginTop: 16 }}>Kifizetések</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {detail.payouts.map(p => (
                      <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#e4e6eb', background: '#0a0d14', borderRadius: 6, padding: '8px 12px' }}>
                        <span>{fmtDate(p.paidAt)} {p.note && <span style={{ color: '#8b8fa3' }}>· {p.note}</span>}</span>
                        <span style={{ fontWeight: 600 }}>{fmtUSD(p.amountUSD)} · {fmtHUF(p.amountHUF)}</span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
}
